'use client';
import React from 'react';
import styles from './FooterLink.module.scss';

interface Props {
  className?: string;
  label: string;
  style?: React.CSSProperties;
  url: string;
}

const FooterLink: React.FC<Props> = ({ label, url }) => (
  <li className={`${styles.footerListItem} footer-link`}>
    <a className={styles.footerAnchor} data-action={`Footer Link Click - ${label}`} href={url}>
      {label}
    </a>
  </li>
);

export default FooterLink;
